import { helper } from './utils/helper';
import { homepageController } from './modules/homepage-controller';

class App {
  constructor() {
    helper.init();
    homepageController.init();
  }
}

window.addEventListener('load', () => new App());



// WEBPACK FOOTER //
// ./src/js/app.js